
import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

import { TitleCasePipe } from "@angular/common";
import { HelperService } from "../../../../../../services/helperService";
import { ChooseServiceWorkshopComponent } from "../choose-service-workshop.component";
import {KeyValue} from '@angular/common';

import moment from "moment";
import { ServiceAdvisorShedule } from '../../../../../../services/api-services/api-interfaces/api-interface-service-advisor-schedule';
import { ServiceAdvisorBlockedSchedule } from '../../../../../../services/api-services/api-interfaces/api-interface-advisor-blocked-schedule';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { APIServiceAdvisorBlockedSchedule } from '../../../../../../services/api-services/api-advisor-blocked-schedule-service';
import { unavaibleAdvisorHours } from '../../../../../../services/api-services/api-interfaces/unavaibleAdvisorHours.interface';
import { TranslateService } from "@ngx-translate/core";
import { DateAdapter } from "@angular/material/core";



@Component({
    selector: 'app-calendarweb',
    templateUrl: './calendarweb.component.html',
    styleUrls: ['./calendarweb.component.sass'],
    providers: [
        TitleCasePipe
    ],
    standalone: false
})

export class CalendarwebComponent {
  // alternatively also the host parameter in the @Component()` decorator can be used
  @HostBinding('class.isDisabled') isDisabled: boolean = false;
  @Output() timeChanged: EventEmitter<string> = new EventEmitter();
  @Output() dateChanged: EventEmitter<string> = new EventEmitter();
  @Input() timeListButtons: string[] = []
  @Input() serviceAdvisorAttention: ServiceAdvisorShedule[] = []
  @Input() advisorBlockedSchedule: ServiceAdvisorBlockedSchedule[] = []
  @Input() dealerBlockedServices: any[] = []
  @Input() typeOfServiceSelected?: number
  @Input() typeOfServiceSelectedName?: any=[]
  @Input()unavaibleAdvisorHours : unavaibleAdvisorHours[]=[]
  @Input() dateFilter!: (date: Date | null) => boolean
  @Input() SchedulForAdvisor: any[] = []
  @Input() LanguageForCountry:any ={}
  @Input() DataRange:number=0

  public calendarTime!: Date | null
  calendarControl = new FormControl(null, Validators.required);
  otrasHoras: any
  timeListDefault: string[] = []
  isDateSelected: boolean = false
  blockHours:any[] = []
  dateNow: Date = new Date
  constructor(public titleCasePipe: TitleCasePipe,
    public helperService: HelperService,
    public chooseServiceWorkshopComponent: ChooseServiceWorkshopComponent,
    public APIServiceAdvisorBlockedSchedule: APIServiceAdvisorBlockedSchedule,
    private translate: TranslateService,private dateAdapter: DateAdapter<any>) { 
    }
  ngOnInit(): void {
    // Material v20 usa Intl.Locale en getFirstDayOfWeek: un locale vacio/undefined lanza RangeError
    const locale = typeof this.LanguageForCountry === 'string' && this.LanguageForCountry
      ? this.LanguageForCountry
      : 'es-CO';
    this.dateAdapter.setLocale(locale);
    this.timeListDefault = this.timeListButtons    

  }
  
 

  SelectDateDinamic() {    
  this.blockHours=[]
  this.timeListButtons=[]
  let dateonDDMMYY = moment(this.calendarTime).format("DD/MM/YYYY")
  this.dateChanged.emit(dateonDDMMYY)
  let selectedDayAttentionHours = this.serviceAdvisorAttention.filter((s) => s.dayNumber === this.calendarTime!.getDay())

 let HourInitial = moment.duration(selectedDayAttentionHours[0].hourInitial).asHours();
  let HourFinal = moment.duration(selectedDayAttentionHours[0].hourFinal).asHours()
  this.isDateSelected=true


    // if(this.dateNow.toDateString() === this.calendarTime!.toDateString()){
    //   this.dateNow.setMinutes(Math.ceil(this.dateNow.getMinutes() / 15) * 15); // Redondea a los 15 minutos siguientes
    //   this.blockHours.push({initialHourBlock:"01:00:00",
    //    finalHourBlock :this.dateNow.getHours()+":"+this.dateNow.getMinutes()+":00"
    // })
    // }

    if(this.advisorBlockedSchedule[0]) {
      this.advisorBlockedSchedule.forEach(element => {
        if ( (this.calendarTime!>= new Date(element.initialDateBlockedServices ) && this.calendarTime!<=new Date(element.finalDateBlockedServices) ) && this.typeOfServiceSelected === element.serviceWorkshopId)
          {     
            this.blockHours.push({initialHourBlock:element.hourInitialBlockedServices,finalHourBlock :element.hourFinaBlockedServices})
          }
      })
    }
 
    this.dealerBlockedServices.forEach(element => {
      if ( (this.calendarTime! >= new Date(element.initialDate ) && this.calendarTime!<=new Date(element.finalDate)) && this.typeOfServiceSelected === element.serviceWorkshopId) 
        {     
          this.blockHours.push({initialHourBlock:element.hourInitial,finalHourBlock :element.hourFinal})
        }
    });

    this.SchedulForAdvisor.forEach(element => {
      if ( (this.calendarTime!.getDate() >= new Date(element.start ).getDate() && this.calendarTime!.getDate()<=new Date(element.end).getDate() &&  this.calendarTime!.getMonth() === new Date(element.start ).getMonth() && this.calendarTime!.getFullYear() ===new Date(element.start ).getFullYear())  ) 
        {     
      
          this.blockHours.push({initialHourBlock:element.time,finalHourBlock :element.end.split('T')[1]})
        }
    });

  const interval = 5;                   // Interval in minutes
  let timeDate = 0                      // Time appoiment route 
  let Hourtemp = ""                     // Hour start save after route
  let blockSelect                       // Block select for Hour
  let hourInitialBlockedServices = 0    // Hour Initial Bloqued
  let hourFinalBlockedServices = 0      // Hour Final Bloqued
  let hourForInDecimal = 0              // route For
  let finalNewBloquedHour = 0

  for (let i = moment.duration("01:00:00").asHours(); i < moment.duration("23:30:00").asHours(); i++) 
    {
      for (let j = 0; j < 60; j += interval) 
      {
        let time = ('0' + i).slice(-2) + ':' + ('0' + j).slice(-2)+':00';
        hourForInDecimal = moment.duration(moment(time, "h:mm A.A.").format("HH:mm:ss")).asHours()
        blockSelect = this.blockHours.filter(blockHours => blockHours.initialHourBlock === time)
        
        if(blockSelect.length > 0)
          {
             finalNewBloquedHour= moment.duration(blockSelect[0].finalHourBlock).asHours()
            blockSelect.forEach(blockHours => {
              
              if(moment.duration(blockHours.finalHourBlock).asHours()>=finalNewBloquedHour){
                 finalNewBloquedHour= moment.duration(blockHours.finalHourBlock).asHours()
              }
            }   
            )
              if(finalNewBloquedHour>=hourFinalBlockedServices )
                {
                  hourInitialBlockedServices = moment.duration(blockSelect[0].initialHourBlock).asHours()
                  hourFinalBlockedServices = finalNewBloquedHour
                }
          }
          if(hourForInDecimal>=HourInitial &&   hourForInDecimal<=HourFinal)
          {
              if (hourInitialBlockedServices<= hourForInDecimal && hourForInDecimal <  hourFinalBlockedServices)
                {
                  timeDate = 0 // Reset the time date for block
                }
              else if(hourForInDecimal>= hourFinalBlockedServices)
                {
                  if(timeDate===0) 
                    {
                      Hourtemp = time // Select start time for appoiment 
                    }
                  timeDate = timeDate + interval
                  if(timeDate=== this.DataRange ) 
                    {
                      timeDate = 0
                      let formattedTime = moment(Hourtemp, 'HH:mm:ss').format('h:mm A');
                      this.timeListButtons.push(formattedTime);
                    }
                }
          }
      }
    }

}
 
  datesFilter = (d: Date | null): boolean => { 
    let test = this.serviceAdvisorAttention[0].dayNumber
    let day = d?.getDay()
    return day===test && d! > new Date()
  }

  hourButton:string =""
  
  timeValue(e) {
    this.hourButton = e
    this.timeChanged.emit(this.hourButton);
  }

  
}